import tntBillingComponent from './tnt_billing.component';

import BillableEvents from './components/billable_events'
import BillingCategoryController from './components/billing_category'
import Contract from './components/contract'
import Customer from './components/customer'
import LocationDistance from './components/location_distance'
import FuelSurcharges from './components/fuel_surcharges'
import ContractType from './components/contract_type'

let tntBillingModule = angular.module('tntBilling', [ 
    BillableEvents,
    BillingCategoryController,
    Contract,
    Customer,
    LocationDistance,
    FuelSurcharges,
    ContractType
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
    .state('billable_events', {
      url: '/billable-event',
      component: 'billableEvents',
      parent:'tntBilling',
      data: {
        requireLogin: true,
        requireACL: 'tnt_billing_billable_events.view'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('billing_category', {
      url: '/billing-category',
      component: 'billingCategory',
      parent:'tntBilling',
      data: {
        requireLogin: true,
        // requireACL: 'billingCategory'
      },
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('contract', {
      url: '/contract',
      component: 'contract',
      parent: 'tntBilling',
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('customer', {
      url: '/customer',
      component: 'customer',
      parent: 'tntBilling',
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('location_distance', {
      url: '/location-distance',
      component: 'locationDistance',
      parent: 'tntBilling',
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('fuel_surcharges',{
      url: '/fuel-surcharges',
      component: 'fuelSurcharges',
      parent: 'tntBilling',
      resolve: {
        hasACL: () => ({})
      }
    })
    .state('contract_type', {
      url: '/contract-type',
      component: 'contractType',
      parent:'tntBilling',
      resolve: {
        hasACL: () => ({})
      }
    })
  })

  .component('tntBilling', tntBillingComponent)

  .name;

export default tntBillingModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/index.js